"use client";

import { ComponentWithLoadingFallback } from "@faire/deprecated-retailer-visitor-shared/components/GhostLoading/ComponentWithLoadingFallback";
import { GhostHeader } from "@faire/deprecated-retailer-visitor-shared/components/GhostLoading/GhostTypography";
import { BrandSearchContext } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageBrandSearch/BrandSearch/BrandSearchContext";
import { Typography } from "@faire/web/slate/Typography";
import { Link } from "@faire/web/ui/LinkAnchor";
import { ResponsiveContentV2 } from "@faire/web/ui/ResponsiveContentV2";
import React, { useContext } from "react";
import styled from "styled-components";

import { BrandNameArrow } from "./BrandNameArrow";

export const BrandName: React.FC<{
  isLoading: boolean;
}> = ({ isLoading }) => {
  const { brand, handleBrandClick, brandPagePath } =
    useContext(BrandSearchContext);

  return (
    <ComponentWithLoadingFallback
      fallback={<GhostHeader />}
      isLoading={isLoading}
    >
      {brand?.name ? (
        <ResponsiveContentV2
          mobile={
            <StyledBrandName variant="subheadingSansMedium">
              <Link to={brandPagePath} onClick={handleBrandClick("brandName")}>
                {brand.name}
              </Link>
              <BrandNameArrow
                linkTo={brandPagePath}
                onClick={handleBrandClick("brandArrow")}
              />
            </StyledBrandName>
          }
          tabletAndAbove={
            <StyledBrandName variant="pageHeaderSerifRegular">
              <Link to={brandPagePath} onClick={handleBrandClick("brandName")}>
                {brand.name}
              </Link>
            </StyledBrandName>
          }
        />
      ) : null}
    </ComponentWithLoadingFallback>
  );
};
const StyledBrandName = styled(Typography).attrs({
  forwardedAs: "span",
})`
  word-break: break-word;
`;
